import { Box, Typography } from '@mui/material';
import { CarrierServicingGrantInputDto, ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { AddCarrierDetails, formatTransactionType, LOGIN_METHOD_OPTIONS } from '../../logic/add-carrier-form';

export interface ReviewStepProps {
  details: AddCarrierDetails;
  servicing: CarrierServicingGrantInputDto[];
  networks: ProjectDto[];
  parentProjectName?: string;
  loginMethod?: string;
  /** Set when the project was created but setting the organisation up failed. */
  retryingProjectId?: string;
}

export function ReviewStep({
  details,
  servicing,
  networks,
  parentProjectName,
  loginMethod,
  retryingProjectId
}: ReviewStepProps) {
  const loginMethodLabel = LOGIN_METHOD_OPTIONS.find((option) => option.value === loginMethod)?.label;
  const networkName = (projectID: string) => networks.find((network) => network.id === projectID)?.name ?? projectID;

  return (
    <Box
      style={{ gap: 16 }}
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Field label="Name" value={details.name.trim()} />
      {details.shortcode.trim() && <Field label="Shortcode" value={details.shortcode.trim()} />}
      {parentProjectName && <Field label="Filed under" value={parentProjectName} />}
      {loginMethodLabel && <Field label="Couriers sign in with" value={loginMethodLabel} />}
      <Box>
        <Typography variant="caption" color="textSecondary">
          Networks
        </Typography>
        {servicing.map((grant) => (
          <Box
            key={grant.projectID}
            sx={{
              marginTop: 0.5
            }}
          >
            <Typography variant="body2">{networkName(grant.projectID)}</Typography>
            <Typography variant="caption" color="textSecondary">
              {grant.permissions.map(formatTransactionType).join(', ')}
            </Typography>
          </Box>
        ))}
      </Box>
      <Typography variant="body2" color="textSecondary">
        {retryingProjectId
          ? 'The carrier’s project already exists. Creating will set its organisation up against that same project — it will not create a second one.'
          : 'Creating will make the carrier’s project, its organisation, a servicing grant for each network above, and a group for couriers who sign themselves up.'}
      </Typography>
    </Box>
  );
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Box>
  );
}
